/**
 * Threads from the retired in-case Athena drawer: one per case, shared with
 * the firm, so the archive shows them read-only (no rename or delete).
 */
export function isCaseConversation(
  c: { scope?: string | null } | null | undefined
): boolean {
  return c?.scope === "case_prep";
}
